<template>
  <div>
    <h1>{{ $t("optima.employee") }} Optima</h1>
    <optima-menu />
    <v-row>
      <v-col cols="12" md="4">
        <ajax-single-file :model.sync="fileId" :label="$t('optima.importEmployeeFromXls')" accept="application/xls" :items.sync="items" />
      </v-col>
      <v-col class="mt-3">
        <v-btn color="primary" @click="load">{{ $t("global.load") }}</v-btn>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="employees"
      :footer-props="{ 'items-per-page-options': [{ text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }] }"
      class="elevation-1"
      hide-default-footer
    >
      <template #item="props">
        <tr>
          <td class="text-left" v-for="item of headers" :key="item.text">
            {{ props.item[item.text] }}
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import OptimaMenu from "../../components/Optima/OptimaMenu";
import AjaxSingleFile from "../../components/CustomInputComponents/AjaxSingleFile";
export default {
  name: "OptimaSettingsEmployeeView",
  components: { AjaxSingleFile, OptimaMenu },
  data: () => ({
    fileId: null,
    items: [],
    employees: []
  }),
  computed: {
    headers() {
      if (this.employees.length === 0) {
        return [{ text: this.$t("optima.notImportedYet") }];
      }
      let header = [];
      for (let key in this.employees[0]) {
        header.push({ text: key, value: key });
      }
      return header;
    }
  },
  methods: {
    load() {
      this.axios.post("optima/import-employee", { fileId: this.fileId }).then(() => {
        this.downloadEmployees();
        this.$store.dispatch("snackbarPush", {
          text: this.$t("global.saved"),
          position: "down"
        });
      });
    },
    downloadEmployees() {
      this.axios.get("optima/get-employee").then(response => {
        this.employees = response.data;
      });
    }
  },
  created() {
    this.downloadEmployees();
  }
};
</script>

<style scoped></style>
